<template>
  <div class="input_number__container" :class="{ disabled: disabled }">
    <span @click="!disabled ? update('increment') : null" class="up-arrow"></span>
    <input
      type="number"
      class="form-control input_number"
      @input="handleClick"
      :placeholder="placeholder"
      :max="max"
      :min="min"
      v-model="inputVal"
      :disabled="disabled"
    />
    <span @click="!disabled ? update('decrement') : null" class="down-arrow"></span>
  </div>
</template>
<script>
export default {
  name: 'BaseInputNumber',
  props: {
    value: {
      type: [Number, String],
      default: '',
    },
    placeholder: {
      type: String,
    },
    max: {
      type: Number,
      default: null,
    },
    min: {
      type: Number,
      default: null,
    },
    maxlength: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMobile: false,
      inputVal: 0,
    };
  },
  mounted() {
    this.inputVal = this.value;
  },
  watch: {
    value() {
      this.inputVal = this.value;
    },
  },
  methods: {
    update(type) {
      if (this.min && Number(this.inputVal) < this.min) {
        this.inputVal = this.min;
      }
      if (type === 'increment') {
        if (
          this.max === null ||
          (this.max !== null && Number(this.inputVal) < this.max)
        ) {
          this.inputVal = Number(this.inputVal) + 1;
        }
      } else if (type === 'decrement') {
        if (
          this.min === null ||
          (this.min !== null && Number(this.inputVal) > this.min)
        ) {
          this.inputVal = Number(this.inputVal) - 1;
        }
      }
    },
    handleClick() {
      if (this.maxlength && this.inputVal.toString().length > this.maxlength) {
        this.inputVal = this.inputVal.toString().slice(0, this.maxlength);
      }
      this.inputVal = Number(this.inputVal);
      if (this.min && this.inputVal < this.min) {
        this.inputVal = this.min;
      }
      this.$emit('input', this.inputVal ? parseInt(this.inputVal, 10) : '');
      this.$emit('keyup', this.inputVal ? parseInt(this.inputVal, 10) : '');
      this.$emit('change', this.inputVal ? parseInt(this.inputVal, 10) : '');
    },
  },
};
</script>
<style lang="scss">
.input_number__container {
  position: relative;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

@mixin arrow-properties($imageUrl) {
  content: url($imageUrl);
  color: $primary;
  position: absolute;
  right: 12px;
  width: 12px;
  line-height: 14px;
  cursor: pointer;
}

.input_number__container .up-arrow {
  @include arrow-properties('/static/images/icons/up_icon.svg');
  top: 7px;
}

.input_number__container .down-arrow {
  @include arrow-properties('/static/images/icons/down_icon.svg');
  bottom: 7px;
}

.input_number__container.disabled .up-arrow,
.input_number__container.disabled .down-arrow {
  opacity: 0.5;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) {
  .input_number__container .down-arrow,
  .input_number__container .up-arrow {
    display: none;
  }
}

@media only screen and (min-device-width: 320px) and (max-device-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2) {
  .input_number__container .down-arrow,
  .input_number__container .up-arrow {
    display: none;
  }
}

@media only screen and (min-device-width: 320px) and (max-device-width: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
  .input_number__container .down-arrow,
  .input_number__container .up-arrow {
    display: none;
  }
}
</style>
